import { render, staticRenderFns } from "./CarouselEditor.vue?vue&type=template&id=fdf0137a&scoped=true&"
import script from "./CarouselEditor.vue?vue&type=script&lang=js&"
export * from "./CarouselEditor.vue?vue&type=script&lang=js&"
import style0 from "./CarouselEditor.vue?vue&type=style&index=0&id=fdf0137a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf0137a",
  null
  
)

export default component.exports